import { render, staticRenderFns } from "./PlacePreview.vue?vue&type=template&id=0b0c4294&scoped=true"
import script from "./PlacePreview.vue?vue&type=script&lang=js"
export * from "./PlacePreview.vue?vue&type=script&lang=js"
import style0 from "./PlacePreview.vue?vue&type=style&index=0&id=0b0c4294&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c4294",
  null
  
)

export default component.exports